import React from 'react';
import {GetOffices} from "../../api/offices/GetOffices";
import FetchOptionsSelect from "./FetshOptionsSelect";
import {useTranslation} from "react-i18next";

const OfficesSelect = ({ onChange,defaultOfficeIds = [], ...props }) => {

    const { t } = useTranslation();

    const formatOfficeOptions = (response) => {
        return response.data.map(fetchOption => ({
            value: fetchOption.id,
            label: fetchOption.name,
            state: fetchOption.state
        }))
    }
    return <FetchOptionsSelect
        onChange={onChange}
        fetchOptionsFunction={GetOffices}
        fetchOptionsFilterParams={{ limit: -1, offset: 0 }}
        loadingPlaceholder={t("Loading Offices...")}
        placeholderText={t("Select office")}
        defaultFetchOptionIds={defaultOfficeIds}
        formatFetchOptionsFunction={formatOfficeOptions}
        {...props}
    />
};

export default OfficesSelect;
